var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TableGrade',{attrs:{"grade-field":"Resultado","items":_vm.analyse,"fields":[
      { key: 'index', label: 'Índice'} ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }